var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3249 14.731C17.7506 11.2758 15.9628 8.70286 14.4086 7.19162C13.9563 6.75187 13.7302 6.53199 13.2307 6.3285C12.7312 6.125 12.3018 6.125 11.4431 6.125H9.55692C8.69821 6.125 8.26884 6.125 7.76932 6.3285C7.2698 6.53199 7.04367 6.75187 6.59141 7.19162C5.03722 8.70286 3.24941 11.2758 2.67511 14.731C2.24781 17.3017 4.61936 19.25 7.26978 19.25H13.7302C16.3806 19.25 18.7522 17.3017 18.3249 14.731Z",
    stroke: "#003371",
    strokeWidth: 1.3125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34954 3.88751C6.16902 3.62476 5.90737 3.26812 6.44787 3.18679C7.00343 3.1032 7.58031 3.4835 8.14498 3.47568C8.65582 3.46861 8.91607 3.24204 9.19529 2.91854C9.48929 2.5779 9.94455 1.75 10.5 1.75C11.0554 1.75 11.5107 2.5779 11.8047 2.91854C12.0839 3.24204 12.3441 3.46861 12.855 3.47568C13.4197 3.4835 13.9966 3.1032 14.5521 3.18679C15.0926 3.26812 14.831 3.62476 14.6505 3.88751L13.8342 5.07556C13.4851 5.58378 13.3105 5.83789 12.9451 5.98145C12.5798 6.125 12.1076 6.125 11.1634 6.125H9.83658C8.89236 6.125 8.42021 6.125 8.05486 5.98145C7.68952 5.83789 7.51494 5.58378 7.16577 5.07556L6.34954 3.88751Z",
    stroke: "#003371",
    strokeWidth: 1.3125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagDashboard);
export default __webpack_public_path__ + "static/media/bag-dashboard.83b676e831e9c1ffa961093e3eba2651.svg";
export { ForwardRef as ReactComponent };